const REQUIRED = ["REACT_APP_BASE_URL"]

const OPTIONAL = ["REACT_APP_TECHNICIAN_PORTAL_URL"]

const read = (key) => {
  const value = process.env[key]
  return typeof value === "string" ? value.trim() : ""
}

const resolved = {}

for (const key of REQUIRED) {
  const value = read(key)
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  resolved[key] = value
}

for (const key of OPTIONAL) {
  const value = read(key)
  if (!value && process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`Optional environment variable not set: ${key}`)
  }
  resolved[key] = value
}

export const env = Object.freeze(resolved)
